module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('em', [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "40%"
    }
  }, [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Add.")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%"
    }
  }, [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Additional MSS., B.L.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Adv.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Advocates’ Library Collection of MSS., N.L.S.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Annals of Loch Cé")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Hennessy, W. M., "), _c('em', [_vm._v("The Annals of Loch Cé")]), _vm._v(", Rolls Series, 1871.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Arb. Lib.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Liber S. Thome de Aberbrothoc")]), _vm._v(", Bannatyne Club, 1848–56.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Argyll Syn.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Minutes of the Synod of Argyll")]), _vm._v(", ed. MacTavish, D.C., SHS, 1943–4.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("AT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Argyll Transcripts, made by 10th Duke of Argyll, Inveraray.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("BDL")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Watson, W. J., "), _c('em', [_vm._v("Scottish Verse from the Book of the Dean of Lismore")]), _vm._v(", SGTS, 1937.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Bellenden, "), _c('em', [_vm._v("History")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("The History and Chronicles of Scotland")]), _vm._v(" written in Latin by Hector Boece, translated into Scots by John Bellenden, ed. Maitland, T., 1821.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("B.L.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("British Library, London.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Black, Catalogue")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Black, R., Catalogue of the classical Gaelic MSS. in N.L.S.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Black, "), _c('em', [_vm._v("Surnames")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Black, G. F., "), _c('em', [_vm._v("The Surnames of Scotland")]), _vm._v(", 1946.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Cal. Charters")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Calendar of charters and other original documents, S.R.O., RH 6.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Campbell, "), _c('em', [_vm._v("Highland Rites")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Campbell, J. L., "), _c('em', [_vm._v("A Collection of Highland Rites and Customes")]), _vm._v(", 1975.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Campbell and Thomson, "), _c('em', [_vm._v("Lhuyd")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Campbell, J. L., and Thomson, D., "), _c('em', [_vm._v("Edward Lhuyd in the Scottish Highlands 1699–1700")]), _vm._v(", 1963.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Campion, "), _c('em', [_vm._v("Historie")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Campion, E., ‘A Historie of Ireland’ in "), _c('em', [_vm._v("The Historie of Ireland")]), _vm._v(", ed. Ware, J., 1633.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Cawdor Bk.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("The Book of the Thanes of Cawdor")]), _vm._v(", Spalding Club, 1859.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Cawdor Papers")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Cawdor Papers, Cawdor Castle.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Church Recs.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Church of Scotland Records, S.R.O., CH 1–4.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Clanranald Bk.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("‘The Book of Clanranald’ in "), _c('em', [_vm._v("Rel. Celt")]), _vm._v("., ii, pp. 138–309.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Clanranald Papers")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Clanranald Papers, S.R.O., GD 201.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("CMJ")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("The Caledonian Medical Journal.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Comrie, "), _c('em', [_vm._v("Scottish Medicine")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Comrie, J. D., "), _c('em', [_vm._v("History of Scottish Medicine")]), _vm._v(", 1932.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Cowan, "), _c('em', [_vm._v("Parishes")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Cowan, I. B., "), _c('em', [_vm._v("The Parishes of Medieval Scotland")]), _vm._v(", SRS, 1967.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("CSP Dom.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Calendar of State Papers, Domestic Series, 1860–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('em', [_vm._v("CSP Scot.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Calendar of the State Papers relating to Scotland and Mary, Queen of Scots 1547–1603")]), _vm._v(", 1898–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("DNB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Dictionary of National Biography.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Duncan, "), _c('em', [_vm._v("Memorials")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Duncan, A., "), _c('em', [_vm._v("Memorials of the Faculty of Physicians and Surgeons of Glasgow 1599–1850")]), _vm._v(", 1896.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Dunvegan Papers")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("MacLeod of Dunvegan Papers, Dunvegan Castle.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("ER")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("The Exchequer Rolls of Scotland, 1878–1908.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("E.U.L.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Edinburgh University Library, Edinburgh.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Fiants, Ire. Eliz.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Calendar of Fiants, Henry VIII to Elizabeth, in First (etc.) Report of the Deputy Keeper of the Public Records in Ireland, 1875–90.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("FM")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Annals of the Kingdom of Ireland by the Four Masters")]), _vm._v(", ed. O’Donovan, J., 1851.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Fraser, "), _c('em', [_vm._v("Sutherland Bk.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Fraser, W., "), _c('em', [_vm._v("The Sutherland Book")]), _vm._v(", 1892.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Fraser, "), _c('em', [_vm._v("Wardlaw MS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Fraser, J., "), _c('em', [_vm._v("Chronicles of the Frasers")]), _vm._v(", ed. MacKay, W., SHS, 1905.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Gen. Coll.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Macfarlane, W., "), _c('em', [_vm._v("Genealogical Collections concerning Families in Scotland")]), _vm._v(", SHS, 1900.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Geog. Coll.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Macfarlane, W., "), _c('em', [_vm._v("Geographical Collections relating to Scotland")]), _vm._v(", SHS, 1906–8.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Giblin, "), _c('em', [_vm._v("Franciscan Mission")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Giblin, C, "), _c('em', [_vm._v("Irish Franciscan Mission to Scotland")]), _vm._v(", 1964.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Glas. Mun.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Munimenta Alme Universitatis Glasguensis")]), _vm._v(", Maitland Club, 1854.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Gregory Coll.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Papers and manuscripts of Donald Gregory given to the Iona Club, 1836, N.L.S.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("GRS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("General Register of Sasines, S.R.O., RS 1–3.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Guthrie, "), _c('em', [_vm._v("Medicine")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Guthrie, G., "), _c('em', [_vm._v("A History of Medicine")]), _vm._v(", 1958.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("HP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("McPhail, J. R. N., "), _c('em', [_vm._v("Highland Papers")]), _vm._v(", SHS, 1914–34.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Inventory of Argyll")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Inventory of the Ancient and Historical Monuments in Argyll, RCAHMS, 1971–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Isles Tests.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Register of Testaments, The Commissariat Record of the Isles, S.R.O., CC 12/3.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Laing MS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Laing manuscript collection formed by David Laing (d. 1878), E.U.L.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Lochbuie Papers")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("MacLaine of Lochbuie Papers, S.R.O., GD 174.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Lord MacDonald MSS.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Lord MacDonald MSS., S.R.O., GD 221.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("MacDonald, "), _c('em', [_vm._v("Clan Donald")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("MacDonald, A. and A., "), _c('em', [_vm._v("The Clan Donald")]), _vm._v(", 1896–1904.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("MacDonald, "), _c('em', [_vm._v("History")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("MacDonald, H. (attrib.), ‘History of the MacDonalds’ in "), _c('em', [_vm._v("HP")]), _vm._v(", i, pp. 6–72.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("MacGill, "), _c('em', [_vm._v("Old Ross-shire")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("MacGill, W., "), _c('em', [_vm._v("Old Ross-shire and Scotland")]), _vm._v(", 1909.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("MacGregor Coll.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("The John MacGregor Collection, S.R.O., GD 50.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("MacKenzie, "), _c('em', [_vm._v("Sàr-Obair")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("MacKenzie, J., "), _c('em', [_vm._v("Sàr-Obair nam Bàrd Gaelach")]), _vm._v(", 1904.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("MacKinnon, "), _c('em', [_vm._v("Catalogue")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("MacKinnon, D., "), _c('em', [_vm._v("A Descriptive Catalogue of Gaelic Manuscripts in the Advocates’ Library, Edinburgh, and elsewhere in Scotland")]), _vm._v(", 1912.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("Major, "), _c('em', [_vm._v("Medicine")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Major, R. H., "), _c('em', [_vm._v("A History of Medicine")]), _vm._v(", 1954.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Martin, "), _c('em', [_vm._v("Western Islands")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Martin, M., "), _c('em', [_vm._v("A Description of the Western Islands of Scotland")]), _vm._v(", 1934.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Muir, "), _c('em', [_vm._v("Church Architecture")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Muir, T. S., "), _c('em', [_vm._v("Characteristics of Old Church Architecture etc. in the Mainland & Western Islands of Scotland")]), _vm._v(", 1861.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Munro Writs")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Writs of Munro of Foulis, 1299–1823, S.R.O., GD 93.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v(" N.L.S.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("National Library of Scotland, Edinburgh.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("N.M.A.S.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("National Museum of Antiquities of Scotland, Edinburgh.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Ó Baoill, "), _c('em', [_vm._v("Eachann Bacach")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Ó Baoill, E., "), _c('em', [_vm._v("Eachann Bacach and other MacLean Poets")]), _vm._v(", SGTS, 1979.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("OPS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Origines Parochiales Scotiae")]), _vm._v(", Bannatyne Club, 1851–5.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("OS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Ordnance Survey.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("OSA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("The Statistical Account of Scotland")]), _vm._v(", 1791–9.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Pais. Reg.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Registrum Monasterii de Passelet")]), _vm._v(", Maitland Club, 1832.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("PBA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Proceedings of the British Academy")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("PRIA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Proceedings of the Royal Irish Academy")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("P.R.O.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Public Record Office, London.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("PRS (Argyll)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Particular Register of Sasines (Argyll), S.R.O., RS 9–10.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("PRS (Inverness)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Particular Register of Sasines (Inverness), S.R.O., RS 36–8.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("PSAS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Proceedings of the Society of Antiquaries of Scotland")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("RCAHMS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Royal Commission on the Ancient and Historical Monuments of Scotland.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Reay Papers")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Reay Papers, S.R.O., GD 84.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Reg. Argyll Syn.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Register of the Synod of Argyll, S.R.O., CH 2/557.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Reg. Deeds")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Register of Deeds, S.R.O., RD 1–4.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Rel. Celt.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Cameron, A., "), _c('em', [_vm._v("Reliquiae Celticae")]), _vm._v(", 1892–4.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("R.I.A.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Royal Irish Academy, Dublin.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("R.I.A. Dict.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Dictionary of the Irish Language")]), _vm._v(", R.I.A., 1913–57, and "), _c('em', [_vm._v("Contributions to a Dictionary of the Irish Language")]), _vm._v(", R.I.A., 1939–75.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("RMS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Registrum Magni Sigilli Regum Scotorum")]), _vm._v(", 1882–1914.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Rot. Scot.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Rotuli Scotiae in Turri Londinensi et in Domo Capitulari Westmonasteriensi Asservati")]), _vm._v(", 1814–19.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("RPC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("The Register of the Privy Council of Scotland")]), _vm._v(", 1877–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("RSS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Registrum Secreti Sigilli Regum Scotorum")]), _vm._v(", 1908–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Ryl. Irish MS.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Irish manuscript, John Rylands University Library of Manchester.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Saltoun Coll.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Saltoun Collection, N.L.S.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Scott, "), _c('em', [_vm._v("Fasti")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Scott, H., "), _c('em', [_vm._v("Fasti Ecclesiae Scoticanae")]), _vm._v(", 1915–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("SGS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Scottish Gaelic Studies")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("SHS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Scottish History Society.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('em', [_vm._v("SHS Misc.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("The Miscellany of the Scottish History Society")]), _vm._v(", SHS, 1893–.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Sinclair, "), _c('em', [_vm._v("Clan Gillean")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Sinclair, A. M., "), _c('em', [_vm._v("The Clan Gillean")]), _vm._v(", 1899.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Smith, "), _c('em', [_vm._v("Islay Bk.")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Smith, G. G., "), _c('em', [_vm._v("The Book of Islay")]), _vm._v(", 1895.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("SP")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Paul, Balfour J., "), _c('em', [_vm._v("The Scots Peerage")]), _vm._v(", 1904–14.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("S.R.O.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Scottish Record Office, H.M. General Register House, Edinburgh.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("SRS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Scottish Record Society.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("SS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Scottish Studies.")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Steer and Bannerman,")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Steer, K. A., and Bannerman, J. W. M., "), _c('em', [_vm._v("Late Medieval")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("Monumental Sculpture")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Monumental Sculpture in the West Highlands")]), _vm._v(", RCAHMS, 1977.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("TA")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Accounts of the Lord High Treasurer of Scotland")]), _vm._v(", 1877–1916.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("T.C.D.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Trinity College, Dublin.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("TGSG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Transactions of the Gaelic Society of Glasgow")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_c('em', [_vm._v("TGSI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_c('em', [_vm._v("Transactions of the Gaelic Society of Inverness")]), _vm._v(".")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Walsh, "), _c('em', [_vm._v("Gleanings")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Walsh, P., "), _c('em', [_vm._v("Gleanings from Irish Manuscripts")]), _vm._v(", 1933.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Walsh, "), _c('em', [_vm._v("Irish Men")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Walsh, P., "), _c('em', [_vm._v("Irish Men of Learning")]), _vm._v(", 1947.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Watson, "), _c('em', [_vm._v("Celtic Place-names")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Watson, W. J., "), _c('em', [_vm._v("The History of the Celtic Place-names of Scotland")]), _vm._v(", 1926.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Watt, "), _c('em', [_vm._v("Fasti")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Watt, D. E. R., "), _c('em', [_vm._v("Fasti Ecclesiae Scoticanae Medii Aevi ad Annum 1638")]), _vm._v(", second draft, 1969.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Whyte, "), _c('em', [_vm._v("Bethunes")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Whyte, T., "), _c('em', [_vm._v("An Historical and Genealogical Account of the Bethunes of the Island of Sky")]), _vm._v(", 1778.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tab_hs"
  }, [_vm._v("Woulfe, "), _c('em', [_vm._v("Sloinnte")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tabs"
  }, [_vm._v("Woulfe, P., "), _c('em', [_vm._v("Sloinnte Gaedheal is Gall")]), _vm._v(", 1923.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c3c9ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 72
// module chunks = 0